<template>
  <div class="messageBox">
    <!-- <ul class="list" v-if="list.length != 0 && list[0].type != 80 && list[0].type != 90">
			<li v-for="(item,index) in list" :key="index">
				<i class="el-icon-close pointer_box" @click="setRead(item,index,false)"></i>
				<h3>{{langtrans().zxjz[languageIndex]}}</h3>
				<p>{{langtrans().sj[languageIndex]}}：{{languageIndex == 0 ? item.description : item.descriptionEn}}</p>
				<p>{{langtrans().sjj[languageIndex]}}：{{setTime(item.createAt)}}</p>
				<el-button class="btn" type="primary" size="mini" @click="setRead(item,index,true)">{{langtrans().czkkxq[languageIndex]}}</el-button>
			</li>
		</ul> -->
      <div
      class="allScll"
      v-if="
        (list.length != 0 && list[0].type == 80) ||
        (list.length != 0 && list[0].type == 90) 
      "
    >
      <div
        class="noiceBox"
        v-for="(item, index) in list"
        :key="index"
        v-if="index == 0"
      >
        <div class="bg"></div>
        <img class="lingdang" src="./../../assets/img/lingdang.png" />
        <p class="close" @click="setRead(item, index, false)">x</p>
        <h3>有新用户报案，请尽快解决！</h3>
        <button type="button" @click="setRead(item, index, true)">
          立即查看
        </button>
      </div>
      <video
        id="myAudio"
        src="./../../../static/img/baoan.mp3"
        controls="controls"
        loop="loop"
        hidden="hidden"
      ></video>
      <!-- <audio id="myAudio" src="./../../../static/img/baoan.mp3" controls="controls" loop="loop" hidden="hidden"></audio> -->
    </div>
  
   
  </div>
</template>

<script>
import { getLunxun, getLunxunRead } from "@/views/axios/api.js";
import constants from "@/util/constants.js";
import langtrans from "./message_box.vue.trans.js";
import canAutoPlay from "can-autoplay";
export default {
  data() {
    return {
      timer: null,
      i: 0,
      list: [],
      token: JSON.parse(window.localStorage.getItem("data")).data,
    };
  },
  computed: {
    languageIndex() {
      return this.$store.state.language;
    },
  },
  methods: {
    langtrans() {
      return langtrans;
    },
    lookover(data) {
      // 点击查看详情
      // window.location.href = data.url;
      window.open(data.url);
      // this.$router.push({
      //   path:data.url
      // })
    },
    lunxun() {
      console.log(window.localStorage.getItem("lunxunTime"));
      console.log(new Date().getTime() - 2000);
      if (
        window.localStorage.getItem("lunxunTime") < new Date().getTime() - 2000) {
        console.log("进来了");
        var t = null;
        if (window.localStorage.getItem("data")) {
          t = JSON.parse(window.localStorage.getItem("data")).data;
        }
        if (t == null) {
          return;
        }
        var data = {
          token: t,
        };
        console.log(data);
        getLunxun(data)
          .then((res) => {
            window.localStorage.setItem("lunxunTime", new Date().getTime());
            console.log(res);
            var data = res.data.obj[0];
            var btn = true;
            if (res.data.obj.length == "0") return;
            if (res.data.code == 0) {
              if (data.id) {
                // setRead(item, index, true)
                if (data.type == "80" || data.type == "90") {
                  this.list = res.data.obj;
                } else {
                  this.list.forEach((item) => {
                    if (item.id == data.id) {
                      btn = false;
                    }
                  });
                  if (btn) {
                    this.list.push(data);
                  }
                }
              }
            }

            if (data.type == "80" || data.type == "90") {
              this.$nextTick(() => {
                var audioStatus = "paused";
                var audio1 = document.getElementById("myAudio");
                audio1.addEventListener("playing", function () {
                  audioStatus = "playing";
                });
                audio1.addEventListener("pause", function () {
                  audioStatus = "paused";
                });
                if (audioStatus == "paused") {
                  setTimeout(() => {
                    audio1.play();
                  }, 1000);
                }
              });
            }
            console.log(this.list);

          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    setRead(dataArr, index, status) {
      console.log(dataArr);
      var data = {
        token: this.token,
        noticeId: dataArr.id,
      };
      getLunxunRead(data)
        .then((res) => {
          if (res.data.code == 0) {
            if (status) {
              this.lookover(dataArr);
              this.list.splice(index, 1);
            } else {
              this.list.splice(index, 1);
            }
          }
          var audio1 = document.getElementById("myAudio");
          audio1.pause();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setTime(time) {
      return constants.time(time);
    },
    startTimer() {
      if (JSON.parse(window.localStorage.getItem("usertype")).data == 1) {
        this.timer = setInterval(() => {
          this.i++;
          canAutoPlay.audio().then(({ result }) => {
            //支持自动播放
            if (result === true) {
              // console.log('叮叮当')
              this.lunxun();
            } else {
              this.lunxun();
              // if(this.i == 1) {
              //       this.$alert(
              //         "检测到您的浏览器不支持媒体自动播放，是否同意播放音频",
              //         "提示",
              //         {
              //           confirmButtonText: "确定",
              //           callback: (action) => {
              //               this.lunxun()
              //           },
              //         }
              //       );
              // }
            }
          });
        }, 3000);
      } else {
        this.lunxun();
      }
    },
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer);
    }
  },
  mounted() {
    this.startTimer();
  },
};
</script>

<style scoped>
.list {
  position: fixed;
  right: 1vw;
  bottom: 1vw;
  z-index: 998;
}

.list li {
  position: relative;
  padding: 0.5vw;
  border: 0.0625vw #ccc solid;
  margin-top: 2vw;
  background: #fff;
  width: 20vw;
  min-height: 10vw;
  border-radius: 0.3vw;
}

.list li h3 {
  font-size: 1.05vw;
  line-height: 3.1vw;
}

.list li p {
  font-size: 1vw;
  line-height: 1.8vw;
}

.list li i {
  position: absolute;
  right: 0.5vw;
  top: 0.5vw;
}

.pointer_box {
  cursor: pointer;
}

.btn {
  margin-top: 0.9vw;
}
.allScll {
  position: fixed;
  top: 0;
  left: 0;
  width: calc(100vw - 20px);
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9;
}
.allScll .noiceBox {
  width: 400px;
  height: 400px;
  background: white;
  border-radius: 5px;
  margin-top: -200px;
  margin-left: -200px;
  position: absolute;
  top: 50%;
  left: 50%;
}
.allScll .noiceBox h3 {
  text-align: center;
  line-height: 70px;
}
.allScll .noiceBox button {
  border: none;
  background: #00abfa;
  padding: 10px 50px;
  color: white;
  border-radius: 3px;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  cursor: pointer;
}
.allScll .noiceBox .bg {
  width: 100%;
  height: 240px;
  background: #cdeefe;
}
.allScll .noiceBox .lingdang {
  position: absolute;
  top: 60px;
  left: 140px;
  width: 130px;
}
.close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: white;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}
.allScll .noiceBox .lingdang {
  animation: antzone 0.4s 0s infinite;
  -webkit-transform-origin: top;
}
@keyframes antzone {
  0%,
  65% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  70% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  75% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  80% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  85% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  90% {
    -webkit-transform: rotate(6deg);
    transform: rotate(6deg);
  }
  95% {
    -webkit-transform: rotate(-6deg);
    transform: rotate(-6deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Tips_box/message_box.vue